import { useOutletContext } from "react-router";
import type { Me } from "./api";

export interface SessionCtx {
  /** undefined - still loading, null - not signed in. */
  me: Me | null | undefined;
}

export function useSession(): SessionCtx {
  return useOutletContext<SessionCtx>();
}
